// document.addEventListener('DOMContentLoaded', function () {
//   // This function will be executed when the DOM is ready.
//   Vue.use(Vuex) // (i) You don't need to do this when using global script tags.
// })

// Vue.use(Vuex) // (i) You don't need to do this when using global script tags.
//Vue.config.productionTip = false

if (window['vue-slick-carousel']) {
	Vue.component('vue-slick-carousel', window['vue-slick-carousel']);
}

Vue.component('v-select', VueSelect.VueSelect);

//

var mainApp = new Vue({
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	el: '#main-app',
	store: vStore,
	i18n,
	data: {
		message: 'Hi Web',
		windowInnerWidth: window.innerWidth,
	},
	mounted() {
		this.$store.dispatch('setUserPathToLab');
		this.setCurrencyCode(this.$store.getters['localization/shopUserLocalization'].currencyCode);
		window.addEventListener('resize', this.handleResize);

		this.$store.dispatch('scrollToTop');

		this.setStoreIsMobile(this.isMobile);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	computed: {
		...Vuex.mapGetters(['pageIsLoading']),
		// ...Vuex.mapGetters('articles', ['articlesArray']),
		userPath() {
			return this.$store.getters['userPath'];
		},

		isMobile() {
			let width = this.windowInnerWidth;

			// if we are in mobile // = 791
			if (width < 900) {
				return true;
			} else {
				return false;
			}
		},
	},
	methods: {
		...Vuex.mapActions(['setStoreIsMobile']),
		...Vuex.mapActions('localization', ['setCurrencyCode', 'setCountryCode']),
		// ...Vuex.mapActions('articles', ['getLastArticles']),
		changeToClinic() {
			this.$store.dispatch('setUserPathToClinic');
		},

		handleResize() {
			this.windowInnerWidth = window.innerWidth;
		},
	},
	watch: {
		isMobile: {
			handler() {
				// update isMobile on store
				this.setStoreIsMobile(this.isMobile);
			},
			deep: false,
		},
	},
});
